import Vue from 'vue';
import Rules from '@/rules';
import api from '@/api'
import util from '@/util'
import Antd from 'ant-design-vue';
// import { DatePicker } from 'ant-design-vue';

// require styles
import 'ant-design-vue/dist/antd.css'
import 'nprogress/nprogress.css'
import '@/assets/less/base.less'

Vue.config.productionTip = false
Vue.use(Rules)
Vue.use(api)
Vue.use(util)
Vue.use(Antd)
// Vue.use(DatePicker);
